export const common = {
  VIEW: "Просмотр",
  COPY: "Скопировать",
  INVALID_DATE_FORMAT: "Недопустимый формат даты",
};
